export default class SetupTeacherActivitiesCtrl {
  constructor ($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog, $timeout, $cookies) {
  // CONSTANTS
    const setupTeacherTypeModulesVM = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    setupTeacherTypeModulesVM.workplan = {}
    setupTeacherTypeModulesVM.submodules = [{ds_name:'Perfil', id_code:0, id_submodule:'isprofile', hasPermission:"modulo-perfil-edit"}, {ds_name:'Portafolio', id_code:1, id_submodule:'isPortfolio', hasPermission:"modulo-portafolio-edit"}]
    console.log(setupTeacherTypeModulesVM.submodules);
  // VARIABLES
    setupTeacherTypeModulesVM.teachertype = []
    setupTeacherTypeModulesVM.teacherCategories = []
    setupTeacherTypeModulesVM.isButtonDisabled = false
  // METHODS
    setupTeacherTypeModulesVM.checkDoWorkplan = checkDoWorkplan
    setupTeacherTypeModulesVM.toggleSubcategories = toggleSubcategories
    setupTeacherTypeModulesVM.saveTeacherActivities = saveTeacherActivities
    setupTeacherTypeModulesVM.categorySubmodule={}
    setupTeacherTypeModulesVM.blockCheckboxes = true

    function activate () {
      return getAllTeachersActivities()
    }

  // SERVICES METHODS

    function getWorkPlanHeader (header) {
      return WorkPlanParametrizationSrv.getWorkPlanHeader.get(header).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          setupTeacherTypeModulesVM.workplan = dataReturn.data
          setupTeacherTypeModulesVM.workplan.id_code = $stateParams.workPlanId
        }
      })
    }

    function saveTeacherActivities () {
      setupTeacherTypeModulesVM.information = processActivitiesInformation()
      setupTeacherTypeModulesVM.isButtonDisabled = true
      let header = {
        modules: setupTeacherTypeModulesVM.information
      }
      WorkPlanParametrizationSrv.addRelationTeachertypeModules.add(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          showModalActivitesSetedUp()
          setupTeacherTypeModulesVM.isButtonDisabled = false
        } else {
          showModalActivitesSetedUpError(dataReturn.message)
          setupTeacherTypeModulesVM.isButtonDisabled = true
        }
      })
    }

    // MODAL DEFINITIONS
    function showModalActivitesSetedUp () {
      let planName = setupTeacherTypeModulesVM.workplan.plan_name
      let workPlanId = $stateParams.workPlanId
      let workPlanIdCloned = $stateParams.workPlanIdCloned
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.planName = planName
          $scope.workPlanId = workPlanId
          $scope.workPlanIdCloned = workPlanIdCloned
          $scope.close = function () {
            $mdDialog.hide()
          }
        }],
        template: require('./modalActivitesSetedUp.html'),
        clickOutsideToClose: false
      })
    };

    function showModalActivitesSetedUpError (message) {
      let errorMessage = message
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.errorMessage = errorMessage
          $scope.close = function () {
            $mdDialog.hide()
          }
        }],
        template: require('./modalActivitesSetedUpError.html'),
        clickOutsideToClose: false
      })
    }

  // METHODS
    function processActivitiesInformation () {
      var result = []
      setupTeacherTypeModulesVM.teachertype.forEach(function (teacherType) {
        var professorType = {}
        if (teacherType) {
          if(teacherType[0] != false || teacherType[1] != false){
            professorType['isProfile'] = teacherType[0] != false ? 1 : 0
            professorType['isPortfolio'] = teacherType[1] != false ? 1 : 0
            professorType['teacherTypeId'] = teacherType[0] != false ? teacherType[0] : teacherType[1]
            result.push(professorType)
          }
        }
      })
      return result
    }

    function checkDoWorkplan (subModuleId, teachertype) {
      if (setupTeacherTypeModulesVM.teachertype[teachertype]) {
        let isChecked = setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId]
        if (isChecked) {
          let object = isTeacherTypeChild(teachertype)
          if (object) {
            enableParentModuleForTeacher(subModuleId, teachertype, object)
          }
          else {
            enableChildModulesForTeacher(subModuleId,teachertype)
          }
        } else {
          disableChildModulesForTeacher(subModuleId, teachertype)
        }
      }

      // validaciones del formulario
      if(isEmptyTeachertype() || !isActivitySelected())
        setupTeacherTypeModulesVM.isButtonDisabled = true
      else
        setupTeacherTypeModulesVM.isButtonDisabled = false

      //setupVM.categorySubmodule
      var count={},count1={};
      for(var i in setupTeacherTypeModulesVM.categorySubmodule){

        if(setupTeacherTypeModulesVM.categorySubmodule[i]!=false){
          var parent_id=i;

          for(var k1 in setupTeacherTypeModulesVM.teachertype[parent_id]){
            if(setupTeacherTypeModulesVM.teachertype[parent_id][k1]!=false){
              if(typeof  count1[parent_id] === 'undefined'){
                count1[parent_id]={};
              }
              count1[parent_id]=setupTeacherTypeModulesVM.teachertype[parent_id];
            }
          }

          if(typeof count1[parent_id] !=='undefined'){
            count1[parent_id]={};
            for(var j in setupTeacherTypeModulesVM.categorySubmodule[i]){
              var id_code=setupTeacherTypeModulesVM.categorySubmodule[i][j].id_code;
              for(var k in setupTeacherTypeModulesVM.teachertype[id_code]){
                if(setupTeacherTypeModulesVM.teachertype[id_code][k]!=false){
                  if(typeof   count1[parent_id][id_code] === 'undefined'){
                    count1[parent_id][j]={};
                  }
                  count1[parent_id][id_code]=setupTeacherTypeModulesVM.categorySubmodule[i][j];
                }
              }
            }
          }
        }
      }

      for(var t in count1){
        var size = Object.keys(count1[t]).length;
        if(size<=0){
          setupTeacherTypeModulesVM.isButtonDisabled = true
        }
      }
    }

    function isEnableAllChilds(teachertype, subModuleId){
      let cant = 0
      let row = {}

      setupTeacherTypeModulesVM.teacherCategories.forEach((parent) => {

        if(setupTeacherTypeModulesVM.teacherCategories.find((object) => object.id_code === teachertype)){
          row = setupTeacherTypeModulesVM.teacherCategories.find((object) => object.id_code === teachertype)
          isParentDisable = true
        }else if(parent.childs.find((object) => object.id_code == teachertype)){
          row = parent
        }
      })

      row.childs.forEach((child) => {
        cant += setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] != false ? 1 : 0
      })

      if(row.childs.length == cant)
        return true
      else
        return false
    }

    function enableParentModuleForTeacher (subModuleId, teachertype, object) {
      if (object) {
        if(isEnableAllChilds(teachertype, subModuleId))
          enable(object, subModuleId)
      } else {
        if (setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId]) {
          let object = isTeacherTypeChild(teachertype)
          if (object) {
            if(isEnableAllChilds(teachertype, subModuleId))
              enable(object, subModuleId)
          }
        }
      }
    }

    function enable (object, subModuleId) {
      let parent = object.parent
      setupTeacherTypeModulesVM.teachertype[parent.id_code][subModuleId] = parent.id_code
    }

    function isTeacherTypeChild (teachertype) {
      let result = false
      setupTeacherTypeModulesVM.teacherCategories.forEach((object) => {
        if (object.childs && object.childs.length > 0) {
          let isChild = object.childs.find((child) => child.id_code === teachertype)
          if (isChild) {
            result = {
              parent: object,
              child: isChild
            }
            return
          }
        }
      })
      return result
    }

    function disableChildModulesForTeacher (subModuleId, teachertype) {

      let row = {}
      let isParentDisable = false

      setupTeacherTypeModulesVM.teacherCategories.forEach((parent) => {

        if(setupTeacherTypeModulesVM.teacherCategories.find((object) => object.id_code === teachertype)){
          row = setupTeacherTypeModulesVM.teacherCategories.find((object) => object.id_code === teachertype)
          isParentDisable = true
        }else if(parent.childs.find((object) => object.id_code == teachertype)){
          row = parent
        }
      })

      if (row && row.childs && row.childs.length > 0) {
        let isParentCheckActive = setupTeacherTypeModulesVM.teachertype[row.id_code][subModuleId]

        row.childs.forEach((child) => {
          if(!isParentCheckActive && isParentDisable){
            setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] = false
          }else
            setupTeacherTypeModulesVM.teachertype[row.id_code][subModuleId] = false
            checkDisableModuleForTeacher(subModuleId,child.id_code)
          })

        setupTeacherTypeModulesVM.teachertype[teachertype][subModuleId] = false

      }
    }

    function enableChildModulesForTeacher (subModuleId, teachertype) {
      let row = setupTeacherTypeModulesVM.teacherCategories.find((object) => object.id_code === teachertype)
      if (row && row.childs && row.childs.length > 0) {
        row.childs.forEach((child) => {
          setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId] = child.id_code
        })
      }
    }

    function isEmptyTeachertype () {
      let arr = processActivitiesInformation()
      return arr.length === 0
    }

    function toggleModulesForTeacher (teachertype,value) {
      for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
        setupTeacherTypeModulesVM.teachertype[teachertype][association] = value
      }
    }

    function enableModulesForTeacher (subModuleId, teachertype) {
      for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
        setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = teachertype // todo change this to match a variable
      }
    }

    function setAllProfessorChecked (check) {
      var result = []
      result[0] = null
      var index = 1
      setupTeacherTypeModulesVM.teacherCategories.forEach(function (teacherType) {
        if (teacherType) {
          result[index] = {}
          setupTeacherTypeModulesVM.submodules.forEach(function (module) {
            if(check)
              result[index][module.id_code] = index
            else
              result[index][module.id_code] = false
          })
          if (teacherType.childs.length > 0) {
            teacherType.childs.forEach(function (child) {
              if (child) {
                index = index + 1
                result[index] = {}
                setupTeacherTypeModulesVM.submodules.forEach(function (module) {
                  if(check)
                    result[index][module.id_code] = index
                  else
                    result[index][module.id_code] = false
                })
              }
            })
          }
        }
        index = index + 1
      })
      return result
    }

    function setWorkplanAlreadyChecked (teacherSubmoduleRelation) {
      teacherSubmoduleRelation.forEach(function (relation) {
        if(setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId]) {
          if(relation.isprofile)
            setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId][0] = relation.teacherTypeId
          if(relation.isPortfolio)
            setupTeacherTypeModulesVM.teachertype[relation.teacherTypeId][1] = relation.teacherTypeId
        }
      })
    }

    function toggleSubcategories (category) {
      if (category.showChilds) {
        category.showChilds = false
      } else {
        category.showChilds = true
      }
    }

    function isActivitySelected() {
      var BreakException = {}
      try {
        setupTeacherTypeModulesVM.teachertype.forEach(function (teacherType) {
          if (teacherType) {
            var count = Object.values(teacherType).reduce(function(n, val) {
                return n + (val === false)
            }, 0);
            if(count == 5){
              throw BreakException
            }
          }
        })
        return true
      }
      catch (e) {
        if (e == BreakException){
          return false
        }
      }
    }

    function checkDisableModuleForTeacher(subModuleId, teachertype){
      var count = Object.values(setupTeacherTypeModulesVM.teachertype[teachertype]).reduce(function(n, val) {
              return n + (val === false)
      }, 0)
      let parent = isTeacherTypeChild(teachertype)
      if(parent){
        /*if(count == 5){
          setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = false
          checkDisableParentModuleForTeacher('1',parent)
        }*/
        checkDisableParentModuleForTeacher(subModuleId,parent)
      }
      else{
        checkDisableDoWorkPlan(subModuleId,teachertype)
      }
    }

    function checkDisableParentModuleForTeacher(subModuleId, object){
      let teachers = getTeacherTypeChilds(object.parent.id_code)
      let count = 0

      teachers.childs.forEach(function (child){
        if(setupTeacherTypeModulesVM.teachertype[child.id_code] &&
          setupTeacherTypeModulesVM.teachertype[child.id_code][subModuleId]){
          count = count + 1
        }
      })

      if(count == 0)
        disable(subModuleId,object)
    }

    function checkDisableDoWorkPlan(subModuleId, teachertype){
      let count = 0
      for (var association in setupTeacherTypeModulesVM.teachertype[teachertype]) {
        if(setupTeacherTypeModulesVM.teachertype[teachertype][association])
          count = count + 1
      }
      if(count == 1)
        setupTeacherTypeModulesVM.teachertype[teachertype]['1'] = false
    }

    function disable (subModuleId,object) {
      let parent = object.parent
      setupTeacherTypeModulesVM.teachertype[parent.id_code][subModuleId] = false
    }

    function getTeacherTypeChilds (teachertype) {
      let result = []
      setupTeacherTypeModulesVM.teacherCategories.forEach((object) => {
        if (object.id_code == teachertype && object.childs.length > 0) {
          result = object
          return
        }
      })
      return result
    }

    function getAllTeachersActivities () {
      return WorkPlanParametrizationSrv.getTeachertypeModules.get().$promise.then((dataReturn) => {
        if(dataReturn.status){
          setupTeacherTypeModulesVM.teacherCategories = dataReturn.teacherCategories
          getRelationTeacherSubmodules(dataReturn.relationTeacherModule)
        }
      })
    }

    function getRelationTeacherSubmodules (header) {
      if (header) {
        if (header.length > 0) {
          setupTeacherTypeModulesVM.teachertype = setAllProfessorChecked(false)
          setWorkplanAlreadyChecked(header)
        } else {
          setupTeacherTypeModulesVM.teachertype = setAllProfessorChecked(true)
        }
        setupTeacherTypeModulesVM.isButtonDisabled = !isActivitySelected() && !isEmptyTeachertype()
        setupTeacherTypeModulesVM.blockCheckboxes = false
      } else {
          console.log('error receiving getRelationTeacherSubmodules')
      }
    }

  // INITIALIZATION
    activate()
  }
}

SetupTeacherActivitiesCtrl.$inject = ['$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog','$timeout','$cookies']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/modules/setupTeacherTypeModulesCtrl.js